<template>
  <span>
    <span>¥</span>
    <span>{{(price/100).toFixed(2)}}</span>
  </span>
</template>
<script>
import Vue from "vue";
export default {
  name: "Currency",
  props: {
    /**
     * 类型
     * 1-字符;2-普通价格图标;3-划线价格图标
     */
    type: {
      default: 2
    },
    price: {
      type: Number
    }
  },
  computed: {
    svg() {
      return this.$store.state.commonSetting.price_svg;
    }
  },
  components: {
    rmb: {
      props: {
        html: String
      },
      render(h) {
        const com = Vue.extend({
          template: this.html
        });
        return h(com, {});
      }
    }
  }
};
</script>
<style lang="scss">
.rmb-svg,
.rmb-svg g,
.rmb-svg path {
  fill: currentColor !important;
  height: 0.9em;
  width: auto;
  width: 0.7em;
}
</style>
